import { render, staticRenderFns } from "./layout-ticket.vue?vue&type=template&id=04b36586&scoped=true&"
import script from "./layout-ticket.vue?vue&type=script&lang=js&"
export * from "./layout-ticket.vue?vue&type=script&lang=js&"
import style0 from "./layout-ticket.vue?vue&type=style&index=0&id=04b36586&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b36586",
  null
  
)

export default component.exports